import { minBreakpoints, responsiveFontSize, theme } from '@noths/polaris-client-ribbons-base';
import {
  LINK_CAROUSEL__HEADING_CLASS,
  LINK_CAROUSEL__LIST_CLASS,
} from '@noths/polaris-client-ribbons-design-system';
import { mediaQuery, pxToRem, stack } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, text } = theme;

export const pageHeadingFontCSS = css`
  text-transform: capitalize;
  color: var(--neutral-black-base);
  ${responsiveFontSize({
    XXS: text.HEADING.LG,
    L: text.HEADING.XL,
  })};
  font-weight: 600;
  text-align: center;
`;

export const pageHeadingWrapperCSS = css`
  h1 {
    ${pageHeadingFontCSS}
  }
`;

export const copyBlockContentCSS = css`
  overflow: auto;
  display: flex;
  justify-content: center;

  a {
    color: var(--brand-purple-base);
  }
  p {
    margin: 0;
    max-width: ${pxToRem(776)};
    text-align: center;
    color: var(--neutral-black-base);
  }
`;

export const pageHeadingCSS = css`
  margin: ${stack(spacing.xl)};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin: ${stack(0)};
    `,
  )};
`;

export const copyBlockAccordionButton = css`
  display: flex;
`;

export const linksCarouselSection = css`
  display: flex;
  justify-content: center;
`;

export const insetSectionContent = css`
  max-width: 776px;
`;

export const linksCarouselWrapper = css`
  width: 100%;
  margin: ${pxToRem(36)} 0 ${pxToRem(12)};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin: ${pxToRem(36)} 0 ${pxToRem(36)};
    `,
  )};

  .${LINK_CAROUSEL__LIST_CLASS} {
    margin: ${pxToRem(spacing.sm)} 0;
  }

  .${LINK_CAROUSEL__HEADING_CLASS} {
    margin: 0;
  }
`;

export const subHeading = css`
  text-align: center;
`;
